import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ReactComponent as PointsIcon } from 'icons/points-icon.svg';
import { ReactComponent as CarIcon } from 'icons/car-filled-logo.svg';
import { ReactComponent as CarChair } from 'icons/car-chair-icon.svg';
import { Button, InputField, TableWrapper } from 'components/Global';
import { useDispatch, useSelector } from 'react-redux';
import { indonesianDateFormat } from 'utils/helpers';
import { checkEmptyObject, getKTPValue, getSIMValue, setCurrency } from 'utils/functionality';
import countryCodes from 'utils/country-codes.json';
import { getCustomerData } from 'features/user/slice';
import InputViolation from 'components/Global/InputViolation';
import { getDetailAccountBank } from 'features/banks/actions';
import Tabs, { TabPane } from 'components/Global/Tabs';
import { useAppContext } from 'components/Context/AppContext';
import { fetchCustomerInfo } from 'features/user/actions';
import { downloadOrderDetail } from 'features/order-detail-pdf/actions';
import InputAdditionals from 'components/Global/InputAdditionals';
import AddOnsField from 'components/Global/AddOnsField';
import ImageViewer from 'components/Global/ImageViewer';
import { useFliptBoolean } from '@flipt-io/flipt-client-react';

const WithoutDriverDetail = ({
  orderData: data,
  getFileName,
  imagePreviewHandler,
  newOrderData,
  oldOrderData,
  confirmHandler,
}) => {
  const [activeTab, setActiveTab] = useState('Data Sekarang');
  const [selectedCountry, setSelectedCountry] = useState({
    name: '',
    code: '',
  });
  const customer = useSelector(getCustomerData);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const customerAccountBank = useSelector((state) => state.banks?.detailAccountBank ?? {});

  const { showToast } = useAppContext();

  const approvalMethod = newOrderData?.approval_setting?.name.includes('update order') ? 'update' : 'delete';

  const findCountryByCode = (code) => countryCodes.find((item) => item.dial_code == code);

  const customerId = searchParams.get('customerId');

  const isUploadNewDocumentEnabled = useFliptBoolean('FLAG_FE_NEW_UPLOAD_DOCUMENT', false, 'anonymous');

  useEffect(() => {
    if (!customerId) return;

    dispatch(getDetailAccountBank(customerId));
    dispatch(fetchCustomerInfo(customerId));
  }, [customerId]);

  useEffect(() => {
    if (customer) {
      setSelectedCountry(findCountryByCode(data?.is_admin_creation ? data?.phone_country_code : customer?.phone_code));
    }
  }, [customer, data]);

  const backHandler = () => {
    navigate(-1);
  };

  const handleExportToPdf = async () => {
    try {
      await dispatch(downloadOrderDetail(data?.transaction_key)).unwrap();
    } catch (error) {
      showToast({ type: 'error', message: 'Gagal Export ke PDF' });
    }
  };

  return (
    <div className="detail-order">
      <TableWrapper
        icon={<CarIcon fill="#009EF7" width="25px" height="25px" />}
        title="Lepas Kunci"
        showExportButton={approvalMethod === 'delete'}
        onExportToPdf={handleExportToPdf}
      >
        {approvalMethod === 'update' ? (
          <Tabs activeTab={activeTab} setActiveTab={setActiveTab}>
            <TabPane label="Data Sekarang">
              <div className="detail-order__renter-detail">
                <div className="detail-order__renter-detail-title">
                  <h1>Detail Penyewa</h1>
                </div>
                <div className="detail-order__renter-detail-body">
                  <InputField label="Nama Lengkap" disabled value={newOrderData?.data?.user_name || '-'} />
                  <InputField label="Email" disabled value={newOrderData?.data?.email || '-'} />

                  <div className="detail-order__renter-detail-body__phone-number">
                    <InputField
                      label="No Handphone"
                      disabled
                      value={
                        newOrderData?.data?.is_admin_creation
                          ? newOrderData?.data?.phone_country_code
                          : customer?.phone_code || '-'
                      }
                      icon={
                        <img
                          src={`https://flagcdn.com/w2560/${selectedCountry?.code?.toLowerCase()}.png`}
                          width={26}
                          height={16}
                          alt={selectedCountry?.name + ' nation flag'}
                        />
                      }
                    />
                    <InputField value={newOrderData?.data?.phone_number || '-'} disabled />
                  </div>

                  <InputField label="Negara" disabled value={selectedCountry?.name || '-'} />

                  <div className="detail-order__renter-detail-body__phone-number">
                    <div className="detail-order__renter-detail-body__phone-number-wrapper">
                      <InputField
                        label="Whatsapp"
                        disabled
                        value={
                          newOrderData?.data?.is_admin_creation
                            ? newOrderData?.data?.phone_country_code
                            : customer?.phone_code || '-'
                        }
                        icon={
                          <img
                            src={`https://flagcdn.com/w2560/${selectedCountry?.code?.toLowerCase()}.png`}
                            width={26}
                            height={16}
                            alt={selectedCountry?.name + ' nation flag'}
                          />
                        }
                      />
                      <div className="detail-order__renter-detail-body__image-wrapper"></div>
                    </div>
                    <InputField disabled value={newOrderData?.data?.wa_number || '-'} />
                  </div>

                  <div />

                  <ImageViewer
                    label="KTP"
                    value={getKTPValue(data, customer, isUploadNewDocumentEnabled)}
                    onClick={imagePreviewHandler}
                  />

                  <ImageViewer
                    label="SIM"
                    value={getSIMValue(data, customer, isUploadNewDocumentEnabled)}
                    onClick={imagePreviewHandler}
                  />
                </div>
              </div>

              <div className="detail-order__rent-detail">
                <div className="detail-order__rent-detail-title">
                  <h1>Detail Sewa</h1>
                </div>
                <div className="detail-order__rent-detail-body">
                  <InputField
                    label="Lokasi Pengantaran"
                    disabled
                    value={newOrderData?.data?.order_detail?.rental_delivery_location || '-'}
                  />
                  <InputField
                    label="Detail Lokasi Pengantaran"
                    disabled
                    value={newOrderData?.data?.order_detail?.rental_delivery_location_detail || '-'}
                  />
                  {newOrderData?.data?.order_detail?.flight_number ? (
                    <InputField
                      label="Nomor Penerbangan"
                      disabled
                      value={newOrderData?.data?.order_detail?.flight_number || '-'}
                    />
                  ) : null}
                  {newOrderData?.data?.order_detail?.landing_time ? (
                    <InputField
                      label="Waktu Mendarat"
                      disabled
                      value={newOrderData?.data?.order_detail?.landing_time || '-'}
                    />
                  ) : null}

                  <InputField
                    label="Lokasi Pengambilan"
                    disabled
                    value={newOrderData?.data?.order_detail?.rental_return_location || '-'}
                  />
                  <InputField
                    label="Detail Lokasi Pengambilan"
                    disabled
                    value={newOrderData?.data?.order_detail?.rental_return_location_detail || '-'}
                  />

                  <InputField
                    label="Tipe Sewa"
                    disabled
                    value={newOrderData?.data?.order_type_id === 1 ? 'Harian' : '-'}
                  />

                  <InputField
                    label="Jenis Mobil"
                    disabled
                    value={newOrderData?.data?.order_detail?.vehicle?.name ?? '-'}
                  />

                  <div className="detail-order__rent-detail-body__rent-date">
                    <InputField
                      label="Tanggal Mulai"
                      disabled
                      value={
                        newOrderData?.data?.order_detail?.start_booking_date
                          ? indonesianDateFormat(newOrderData?.data?.order_detail?.start_booking_date)
                          : '-'
                      }
                    />
                    <InputField
                      label="Jam Mulai"
                      disabled
                      value={newOrderData?.data?.order_detail?.start_booking_time || '-'}
                    />
                  </div>

                  <div className="detail-order__rent-detail-body__rent-date">
                    <InputField
                      label="Tanggal Selesai"
                      disabled
                      value={
                        newOrderData?.data?.order_detail?.end_booking_date
                          ? indonesianDateFormat(newOrderData?.data?.order_detail?.end_booking_date)
                          : '-'
                      }
                    />
                    <InputField
                      label="Jam Selesai"
                      disabled
                      value={newOrderData?.data?.order_detail?.end_booking_time || '-'}
                    />
                  </div>

                  <div className="detail-order__rent-detail-body__rent-date">
                    <InputField
                      label="Jumlah Penumpang"
                      icon={<CarChair />}
                      iconPosition="start"
                      disabled
                      value={
                        newOrderData?.data?.order_detail?.passenger_number
                          ? `${newOrderData?.data?.order_detail?.passenger_number} Orang`
                          : '0'
                      }
                    />
                    <InputField
                      label="Plat Mobil"
                      disabled
                      value={newOrderData?.data?.order_detail?.vehicle?.license_number ?? '-'}
                    />
                  </div>

                  <div className="detail-order__rent-detail-body__rent-date">
                    <InputField
                      label="Kapasitas Koper"
                      disabled
                      value={newOrderData?.data?.order_detail?.vehicle?.max_suitcase ?? '-'}
                    />
                    <InputField
                      label="Koper yang dibawa"
                      disabled
                      value={newOrderData?.data?.order_detail?.baggage ?? 0}
                    />
                  </div>

                  {newOrderData?.data?.customer_name_meet_and_greet ? (
                    <InputField
                      label="Meet and Greet Board"
                      disabled
                      value={newOrderData?.data?.customer_name_meet_and_greet || '-'}
                    />
                  ) : null}
                </div>
              </div>

              <div className="detail-order__price-detail">
                <div className="detail-order__price-detail-title">
                  <h1>Detail Deposit</h1>
                </div>
                <div className="detail-order__price-detail-body">
                  <InputField label="Nama Akun" disabled value={customerAccountBank.nama_rek || '-'} />
                  <InputField label="No Rekening" disabled value={customerAccountBank.no_rek || '-'} />
                  <InputField label="Nama Bank" disabled value={customerAccountBank.nama_bank || '-'} />
                </div>
              </div>

              <AddOnsField data={newOrderData?.data?.addons} totalPrice={newOrderData?.data?.addon_total_price} />

              <div className="detail-order__voucher-detail">
                <div className="detail-order__voucher-detail-title">
                  <h1>Voucher</h1>
                </div>
                <div className="detail-order__voucher-detail-body">
                  <InputField label="Nama Voucher" disabled value={newOrderData?.data?.vouchers?.[0].name || '-'} />
                  <InputField label="Kode Voucher" disabled value={newOrderData?.data?.vouchers?.[0].code || '-'} />
                  <InputField
                    label="Harga Potongan"
                    disabled
                    value={setCurrency(newOrderData?.data?.vouchers?.[0].value) || '-'}
                  />
                </div>
              </div>

              <div className="detail-order__price-detail">
                <div className="detail-order__price-detail-title">
                  <h1>Rincian Biaya</h1>
                </div>
                <div className="detail-order__price-detail-body">
                  <InputField
                    label="Biaya Sewa Mobil"
                    disabled
                    value={setCurrency(newOrderData?.data?.booking_price) || '-'}
                  />
                  <InputField label="Deposit" disabled value={setCurrency(newOrderData?.data?.deposit) || '-'} />
                  <InputField
                    label="Deposit e-Toll"
                    disabled
                    value={setCurrency(newOrderData?.data?.deposit_e_toll) || '-'}
                  />
                  <InputField
                    label="Pembayaran Dengan Point"
                    disabled
                    value={newOrderData?.data?.point}
                    icon={<PointsIcon />}
                    iconPosition="start"
                  />
                  <InputField
                    label="Overtime"
                    disabled
                    value={setCurrency(newOrderData?.data?.over_time_price) || '-'}
                  />
                  <InputField
                    label="One Day Charge"
                    disabled
                    value={setCurrency(newOrderData?.data?.one_day_order_charge) || '-'}
                  />
                  <InputField
                    label="Outside Operational Hour Charge"
                    disabled
                    value={setCurrency(newOrderData?.data?.outside_operational_charge) || '-'}
                  />
                  <InputField
                    label="Exceed Max Passenger Charge"
                    disabled
                    value={setCurrency(newOrderData?.data?.exceed_passenger_price) || '-'}
                  />
                  <InputField
                    label="Biaya Lokasi Pengantaran"
                    disabled
                    value={setCurrency(newOrderData?.data?.rental_delivery_fee) || '-'}
                  />
                  <InputField
                    label="Biaya Pengembalian"
                    disabled
                    value={setCurrency(newOrderData?.data?.rental_return_fee) || '-'}
                  />
                  {newOrderData?.data?.price_component
                    ?.filter((item) => item?.type === 'charges')
                    ?.map((item, idx) => (
                      <InputField
                        key={idx}
                        label={`Holiday Charge (${item?.label})`}
                        disabled
                        value={setCurrency(item?.amount, newOrderData?.data?.currency) || '-'}
                      />
                    ))}
                  <InputField
                    label="Charge Payment Gateway Platform"
                    disabled
                    value={setCurrency(newOrderData?.data?.disbursement?.total_amount_external_payment_fee) || '-'}
                  />
                  <InputField
                    label="Customer Service Platform"
                    disabled
                    value={setCurrency(newOrderData?.data?.disbursement?.total_amount_customer_service_fee) || '-'}
                  />

                  {newOrderData?.data?.fee_meet_greet_board ? (
                    <InputField
                      label="Biaya Meet and Greet Board"
                      disabled
                      value={
                        newOrderData?.data?.fee_meet_greet_board
                          ? setCurrency(newOrderData.data.fee_meet_greet_board)
                          : '-'
                      }
                    />
                  ) : null}
                </div>
                <div className="detail-order__price-detail-body__input-violation">
                  <InputViolation
                    violationList={[]}
                    totalPrice={newOrderData?.data?.order_violations
                      ?.map((item) => item.cost)
                      ?.reduce((acc, cVal) => acc + cVal, 0)}
                    violationPrice={0}
                    data={newOrderData?.data?.order_violations || []}
                    isOnEdit={false}
                  />
                </div>
                <div className="detail-order__price-detail-body__input-violation">
                  <InputAdditionals
                    additionalList={[]}
                    totalPrice={newOrderData?.data?.order_additional_fees
                      ?.map((item) => item.value)
                      ?.reduce((acc, cVal) => acc + cVal, 0)}
                    additionalPrice={0}
                    data={newOrderData?.data?.order_additional_fees || []}
                    isOnEdit={false}
                  />
                </div>
                <div className="detail-order__price-detail-body__payment-type">
                  <div className="detail-order__price-detail-body">
                    <InputField
                      label="Tipe Pembayaran"
                      disabled
                      value={newOrderData?.data?.type === 'HALF' ? 'Pembayaran DP 50%' : 'Pembayaran Full'}
                    />
                    <InputField
                      label="Biaya Bayar DP 50%"
                      disabled
                      value={newOrderData?.data?.type === 'HALF' ? setCurrency(newOrderData?.data?.down_payment) : '-'}
                    />
                    <InputField
                      label="Biaya selanjutnya yang harus dibayar"
                      disabled
                      value={newOrderData?.data?.type === 'HALF' ? setCurrency(newOrderData?.data?.remainder) : '-'}
                    />
                    {newOrderData?.data?.type === 'HALF' ? (
                      <InputField
                        label="Status Pembayaran DP"
                        disabled
                        value={newOrderData?.data?.payment_time === null ? 'Belum Lunas' : 'Lunas' || '-'}
                      />
                    ) : null}
                  </div>
                </div>

                <div className="detail-order__price-detail-body__payment-total">
                  <div className="detail-order__price-detail-body">
                    <InputField
                      label="Total Keseluruhan"
                      disabled
                      value={setCurrency(newOrderData?.data?.total_payment) || '-'}
                    />
                  </div>
                </div>
              </div>

              <div className="detail-order__payment-detail">
                <div className="detail-order__payment-detail-title">
                  <h1>Pembayaran</h1>
                </div>
                <div className="detail-order__payment-detail-body">
                  <InputField label="Status Pembayaran" disabled value={newOrderData?.data?.order_status || '-'} />

                  <div className="detail-order__payment-detail-body__payment-method">
                    <InputField
                      label="Metode Pembayaran"
                      disabled
                      value={
                        newOrderData?.data?.disbursement?.payment?.method
                          ? newOrderData?.data?.disbursement.payment.method
                          : '-'
                      }
                    />
                  </div>

                  {Object.prototype.hasOwnProperty.call(newOrderData, 'disbursement') ? (
                    <>
                      <InputField
                        label="Nama Rekening"
                        disabled
                        value={
                          Object.prototype.hasOwnProperty.call(newOrderData, 'disbursement_reconfirmation')
                            ? [...newOrderData.data.disbursement_reconfirmation].pop()?.sender_name
                            : newOrderData?.data?.disbursement?.sender_name || '-'
                        }
                      />

                      <InputField
                        label="Nama Bank"
                        disabled
                        value={
                          Object.prototype.hasOwnProperty.call(newOrderData, 'disbursement_reconfirmation')
                            ? [...newOrderData.data.disbursement_reconfirmation].pop()?.sender_bank_name
                            : newOrderData?.data?.disbursement?.sender_bank_name || '-'
                        }
                      />

                      <div className="detail-order__payment-detail-body__preview-image">
                        <InputField
                          label="Foto Bukti Transfer"
                          disabled
                          value={getFileName(
                            Object.prototype.hasOwnProperty.call(newOrderData, 'disbursement_reconfirmation')
                              ? [...newOrderData.data.disbursement_reconfirmation].pop()?.reconfirmation_image
                              : newOrderData?.data?.disbursement?.disbursement_confirmation_image,
                          )}
                          className="preview-image-input"
                        />

                        <Button
                          bgColor="#D9D9D9"
                          textColor="#000000"
                          className="preview-image-btn"
                          onClick={() =>
                            imagePreviewHandler(
                              Object.prototype.hasOwnProperty.call(newOrderData, 'disbursement_reconfirmation')
                                ? [...newOrderData.data.disbursement_reconfirmation].pop()?.reconfirmation_image
                                : newOrderData?.data?.disbursement?.disbursement_confirmation_image,
                            )
                          }
                        >
                          Lihat
                        </Button>
                      </div>

                      <div />
                    </>
                  ) : null}
                </div>
              </div>
            </TabPane>

            {!checkEmptyObject(oldOrderData) && newOrderData?.approval_setting?.name.includes('update order') ? (
              <TabPane label="Data Sebelum">
                <div className="detail-order__renter-detail">
                  <div className="detail-order__renter-detail-title">
                    <h1>Detail Penyewa</h1>
                  </div>
                  <div className="detail-order__renter-detail-body">
                    <InputField label="Nama Lengkap" disabled value={oldOrderData?.user_name || '-'} />
                    <InputField label="Email" disabled value={oldOrderData?.email || '-'} />

                    <div className="detail-order__renter-detail-body__phone-number">
                      <InputField
                        label="No Handphone"
                        disabled
                        value={
                          oldOrderData?.is_admin_creation
                            ? oldOrderData?.phone_country_code
                            : customer?.phone_code || '-'
                        }
                        icon={
                          <img
                            src={`https://flagcdn.com/w2560/${selectedCountry?.code?.toLowerCase()}.png`}
                            width={26}
                            height={16}
                            alt={selectedCountry?.name + ' nation flag'}
                          />
                        }
                      />
                      <InputField value={oldOrderData?.phone_number || '-'} disabled />
                    </div>

                    <InputField label="Negara" disabled value={selectedCountry?.name || '-'} />

                    <div className="detail-order__renter-detail-body__phone-number">
                      <div className="detail-order__renter-detail-body__phone-number-wrapper">
                        <InputField
                          label="Whatsapp"
                          disabled
                          value={
                            oldOrderData?.is_admin_creation
                              ? oldOrderData?.phone_country_code
                              : customer?.phone_code || '-'
                          }
                          icon={
                            <img
                              src={`https://flagcdn.com/w2560/${selectedCountry?.code?.toLowerCase()}.png`}
                              width={26}
                              height={16}
                              alt={selectedCountry?.name + ' nation flag'}
                            />
                          }
                        />
                        <div className="detail-order__renter-detail-body__image-wrapper"></div>
                      </div>
                      <InputField disabled value={oldOrderData?.wa_number || '-'} />
                    </div>

                    <div />

                    <ImageViewer
                      label="KTP"
                      value={getKTPValue(data, customer, isUploadNewDocumentEnabled)}
                      onClick={imagePreviewHandler}
                    />

                    <ImageViewer
                      label="SIM"
                      value={getSIMValue(data, customer, isUploadNewDocumentEnabled)}
                      onClick={imagePreviewHandler}
                    />
                  </div>
                </div>

                <div className="detail-order__rent-detail">
                  <div className="detail-order__rent-detail-title">
                    <h1>Detail Sewa</h1>
                  </div>
                  <div className="detail-order__rent-detail-body">
                    <InputField
                      label="Lokasi Pengantaran"
                      disabled
                      value={oldOrderData?.order_detail?.rental_delivery_location || '-'}
                    />
                    <InputField
                      label="Detail Lokasi Pengantaran"
                      disabled
                      value={oldOrderData?.order_detail?.rental_delivery_location_detail || '-'}
                    />
                    {oldOrderData?.order_detail?.flight_number ? (
                      <InputField
                        label="Nomor Penerbangan"
                        disabled
                        value={oldOrderData?.order_detail?.flight_number || '-'}
                      />
                    ) : null}
                    {oldOrderData?.order_detail?.landing_time ? (
                      <InputField
                        label="Waktu Mendarat"
                        disabled
                        value={oldOrderData?.order_detail?.landing_time || '-'}
                      />
                    ) : null}
                    <InputField
                      label="Lokasi Pengambilan"
                      disabled
                      value={oldOrderData?.order_detail?.rental_return_location || '-'}
                    />
                    <InputField
                      label="Detail Lokasi Pengambilan"
                      disabled
                      value={oldOrderData?.order_detail?.rental_return_location_detail || '-'}
                    />
                    <InputField label="Tipe Sewa" disabled value={oldOrderData?.order_type_id === 1 ? 'Harian' : '-'} />
                    <InputField label="Jenis Mobil" disabled value={oldOrderData?.order_detail?.vehicle?.name ?? '-'} />
                    <div className="detail-order__rent-detail-body__rent-date">
                      <InputField
                        label="Tanggal Mulai"
                        disabled
                        value={
                          oldOrderData?.order_detail?.start_booking_date
                            ? indonesianDateFormat(oldOrderData?.order_detail?.start_booking_date)
                            : '-'
                        }
                      />
                      <InputField
                        label="Jam Mulai"
                        disabled
                        value={oldOrderData?.order_detail?.start_booking_time || '-'}
                      />
                    </div>
                    <div className="detail-order__rent-detail-body__rent-date">
                      <InputField
                        label="Tanggal Selesai"
                        disabled
                        value={
                          oldOrderData?.order_detail?.end_booking_date
                            ? indonesianDateFormat(oldOrderData?.order_detail?.end_booking_date)
                            : '-'
                        }
                      />
                      <InputField
                        label="Jam Selesai"
                        disabled
                        value={oldOrderData?.order_detail?.end_booking_time || '-'}
                      />
                    </div>
                    <div className="detail-order__rent-detail-body__rent-date">
                      <InputField
                        label="Jumlah Penumpang"
                        icon={<CarChair />}
                        iconPosition="start"
                        disabled
                        value={
                          oldOrderData?.order_detail?.passenger_number
                            ? `${oldOrderData?.order_detail?.passenger_number} Orang`
                            : '0'
                        }
                      />
                      <InputField
                        label="Plat Mobil"
                        disabled
                        value={oldOrderData?.order_detail?.vehicle?.license_number ?? '-'}
                      />
                    </div>

                    <div className="detail-order__rent-detail-body__rent-date">
                      <InputField
                        label="Kapasitas Koper"
                        disabled
                        value={oldOrderData?.order_detail?.vehicle?.max_suitcase ?? '-'}
                      />
                      <InputField label="Koper yang dibawa" disabled value={oldOrderData?.order_detail?.baggage ?? 0} />
                    </div>

                    {oldOrderData?.data?.customer_name_meet_and_greet ? (
                      <InputField
                        label="Meet and Greet Board"
                        disabled
                        value={oldOrderData?.data?.customer_name_meet_and_greet || '-'}
                      />
                    ) : null}
                  </div>
                </div>

                <div className="detail-order__price-detail">
                  <div className="detail-order__price-detail-title">
                    <h1>Detail Deposit</h1>
                  </div>
                  <div className="detail-order__price-detail-body">
                    <InputField label="Nama Akun" disabled value={customerAccountBank.nama_rek || '-'} />
                    <InputField label="No Rekening" disabled value={customerAccountBank.no_rek || '-'} />
                    <InputField label="Nama Bank" disabled value={customerAccountBank.nama_bank || '-'} />
                  </div>
                </div>

                <AddOnsField data={oldOrderData?.addons} totalPrice={oldOrderData?.addon_total_price} />

                <div className="detail-order__voucher-detail">
                  <div className="detail-order__voucher-detail-title">
                    <h1>Voucher</h1>
                  </div>
                  <div className="detail-order__voucher-detail-body">
                    <InputField label="Nama Voucher" disabled value={oldOrderData?.vouchers?.[0].name || '-'} />
                    <InputField label="Kode Voucher" disabled value={oldOrderData?.vouchers?.[0].code || '-'} />
                    <InputField
                      label="Harga Potongan"
                      disabled
                      value={setCurrency(oldOrderData?.vouchers?.[0].value) || '-'}
                    />
                  </div>
                </div>

                <div className="detail-order__price-detail">
                  <div className="detail-order__price-detail-title">
                    <h1>Rincian Biaya</h1>
                  </div>
                  <div className="detail-order__price-detail-body">
                    <InputField
                      label="Biaya Sewa Mobil"
                      disabled
                      value={setCurrency(oldOrderData?.booking_price) || '-'}
                    />
                    <InputField label="Deposit" disabled value={setCurrency(oldOrderData?.deposit) || '-'} />
                    <InputField
                      label="Deposit e-Toll"
                      disabled
                      value={setCurrency(oldOrderData?.deposit_e_toll) || '-'}
                    />
                    <InputField
                      label="Pembayaran Dengan Point"
                      disabled
                      value={oldOrderData?.point}
                      icon={<PointsIcon />}
                      iconPosition="start"
                    />
                    <InputField label="Overtime" disabled value={setCurrency(oldOrderData?.over_time_price) || '-'} />
                    <InputField
                      label="One Day Charge"
                      disabled
                      value={setCurrency(oldOrderData?.one_day_order_charge) || '-'}
                    />
                    <InputField
                      label="Outside Operational Hour Charge"
                      disabled
                      value={setCurrency(oldOrderData?.outside_operational_charge) || '-'}
                    />
                    <InputField
                      label="Exceed Max Passenger Charge"
                      disabled
                      value={setCurrency(oldOrderData?.exceed_passenger_price) || '-'}
                    />
                    <InputField
                      label="Biaya Lokasi Pengantaran"
                      disabled
                      value={setCurrency(oldOrderData?.rental_delivery_fee) || '-'}
                    />
                    <InputField
                      label="Biaya Pengembalian"
                      disabled
                      value={setCurrency(oldOrderData?.rental_return_fee) || '-'}
                    />
                    {oldOrderData?.price_component
                      ?.filter((item) => item?.type === 'charges')
                      ?.map((item, idx) => (
                        <InputField
                          key={idx}
                          label={`Holiday Charge (${item?.label})`}
                          disabled
                          value={setCurrency(item?.amount, oldOrderData?.currency) || '-'}
                        />
                      ))}
                    <InputField
                      label="Charge Payment Gateway Platform"
                      disabled
                      value={setCurrency(oldOrderData?.disbursement?.total_amount_external_payment_fee) || '-'}
                    />
                    <InputField
                      label="Customer Service Platform"
                      disabled
                      value={setCurrency(oldOrderData?.disbursement?.total_amount_customer_service_fee) || '-'}
                    />

                    {oldOrderData?.fee_meet_greet_board ? (
                      <InputField
                        label="Biaya Meet and Greet Board"
                        disabled
                        value={
                          oldOrderData?.fee_meet_greet_board ? setCurrency(oldOrderData.fee_meet_greet_board) : '-'
                        }
                      />
                    ) : null}
                  </div>
                  <div className="detail-order__price-detail-body__input-violation">
                    <InputViolation
                      violationList={[]}
                      totalPrice={oldOrderData?.order_violations
                        ?.map((item) => item.cost)
                        ?.reduce((acc, cVal) => acc + cVal, 0)}
                      violationPrice={0}
                      data={oldOrderData?.order_violations || []}
                      isOnEdit={false}
                    />
                  </div>
                  <div className="detail-order__price-detail-body__input-violation">
                    <InputAdditionals
                      additionalList={[]}
                      totalPrice={oldOrderData?.order_additional_fees
                        ?.map((item) => item.value)
                        ?.reduce((acc, cVal) => acc + cVal, 0)}
                      additionalPrice={0}
                      data={oldOrderData?.order_additional_fees || []}
                      isOnEdit={false}
                    />
                  </div>
                  <div className="detail-order__price-detail-body__payment-type">
                    <div className="detail-order__price-detail-body">
                      <InputField
                        label="Tipe Pembayaran"
                        disabled
                        value={oldOrderData.type === 'HALF' ? 'Pembayaran DP 50%' : 'Pembayaran Full'}
                      />
                      <InputField
                        label="Biaya Bayar DP 50%"
                        disabled
                        value={oldOrderData.type === 'HALF' ? setCurrency(oldOrderData.down_payment) : '-'}
                      />
                      <InputField
                        label="Biaya selanjutnya yang harus dibayar"
                        disabled
                        value={oldOrderData.type === 'HALF' ? setCurrency(oldOrderData.remainder) : '-'}
                      />
                      {oldOrderData.type === 'HALF' ? (
                        <InputField
                          label="Status Pembayaran DP"
                          disabled
                          value={oldOrderData?.payment_time === null ? 'Belum Lunas' : 'Lunas' || '-'}
                        />
                      ) : null}
                    </div>
                  </div>

                  <div className="detail-order__price-detail-body__payment-total">
                    <div className="detail-order__price-detail-body">
                      <InputField
                        label="Total Keseluruhan"
                        disabled
                        value={setCurrency(oldOrderData?.total_payment) || '-'}
                      />
                    </div>
                  </div>
                </div>

                <div className="detail-order__payment-detail">
                  <div className="detail-order__payment-detail-title">
                    <h1>Pembayaran</h1>
                  </div>
                  <div className="detail-order__payment-detail-body">
                    <InputField label="Status Pembayaran" disabled value={oldOrderData?.order_status || '-'} />

                    <div className="detail-order__payment-detail-body__payment-method">
                      <InputField
                        label="Metode Pembayaran"
                        disabled
                        value={
                          oldOrderData?.disbursement?.payment?.method ? oldOrderData?.disbursement.payment.method : '-'
                        }
                      />
                    </div>

                    {Object.prototype.hasOwnProperty.call(oldOrderData, 'disbursement') ? (
                      <>
                        <InputField
                          label="Nama Rekening"
                          disabled
                          value={
                            Object.prototype.hasOwnProperty.call(oldOrderData, 'disbursement_reconfirmation')
                              ? [...oldOrderData.disbursement_reconfirmation].pop()?.sender_name
                              : oldOrderData?.disbursement?.sender_name || '-'
                          }
                        />

                        <InputField
                          label="Nama Bank"
                          disabled
                          value={
                            Object.prototype.hasOwnProperty.call(oldOrderData, 'disbursement_reconfirmation')
                              ? [...oldOrderData.disbursement_reconfirmation].pop()?.sender_bank_name
                              : oldOrderData?.disbursement?.sender_bank_name || '-'
                          }
                        />

                        <div className="detail-order__payment-detail-body__preview-image">
                          <InputField
                            label="Foto Bukti Transfer"
                            disabled
                            value={getFileName(
                              Object.prototype.hasOwnProperty.call(oldOrderData, 'disbursement_reconfirmation')
                                ? [...oldOrderData.disbursement_reconfirmation].pop()?.reconfirmation_image
                                : oldOrderData?.disbursement?.disbursement_confirmation_image,
                            )}
                            className="preview-image-input"
                          />

                          <Button
                            bgColor="#D9D9D9"
                            textColor="#000000"
                            className="preview-image-btn"
                            onClick={() =>
                              imagePreviewHandler(
                                Object.prototype.hasOwnProperty.call(oldOrderData, 'disbursement_reconfirmation')
                                  ? [...oldOrderData.disbursement_reconfirmation].pop()?.reconfirmation_image
                                  : oldOrderData?.disbursement?.disbursement_confirmation_image,
                              )
                            }
                          >
                            Lihat
                          </Button>
                        </div>

                        <div />
                      </>
                    ) : null}
                  </div>
                </div>
              </TabPane>
            ) : (
              <div />
            )}
          </Tabs>
        ) : (
          <>
            <div className="detail-order__renter-detail">
              <div className="detail-order__renter-detail-title">
                <h1>Detail Penyewa</h1>
              </div>
              <div className="detail-order__renter-detail-body">
                <InputField label="Nama Lengkap" disabled value={newOrderData?.data?.user_name || '-'} />
                <InputField label="Email" disabled value={newOrderData?.data?.email || '-'} />

                <div className="detail-order__renter-detail-body__phone-number">
                  <InputField
                    label="No Handphone"
                    disabled
                    value={
                      newOrderData?.data?.is_admin_creation
                        ? newOrderData?.data?.phone_country_code
                        : customer?.phone_code || '-'
                    }
                    icon={
                      <img
                        src={`https://flagcdn.com/w2560/${selectedCountry?.code?.toLowerCase()}.png`}
                        width={26}
                        height={16}
                        alt={selectedCountry?.name + ' nation flag'}
                      />
                    }
                  />
                  <InputField value={newOrderData?.data?.phone_number || '-'} disabled />
                </div>

                <InputField label="Negara" disabled value={selectedCountry?.name || '-'} />

                <div className="detail-order__renter-detail-body__phone-number">
                  <div className="detail-order__renter-detail-body__phone-number-wrapper">
                    <InputField
                      label="Whatsapp"
                      disabled
                      value={
                        newOrderData?.data?.is_admin_creation
                          ? newOrderData?.data?.phone_country_code
                          : customer?.phone_code || '-'
                      }
                      icon={
                        <img
                          src={`https://flagcdn.com/w2560/${selectedCountry?.code?.toLowerCase()}.png`}
                          width={26}
                          height={16}
                          alt={selectedCountry?.name + ' nation flag'}
                        />
                      }
                    />
                    <div className="detail-order__renter-detail-body__image-wrapper"></div>
                  </div>
                  <InputField disabled value={newOrderData?.data?.wa_number || '-'} />
                </div>

                <div />

                <ImageViewer
                  label="KTP"
                  value={getKTPValue(data, customer, isUploadNewDocumentEnabled)}
                  onClick={imagePreviewHandler}
                />

                <ImageViewer
                  label="SIM"
                  value={getSIMValue(data, customer, isUploadNewDocumentEnabled)}
                  onClick={imagePreviewHandler}
                />
              </div>
            </div>

            <div className="detail-order__rent-detail">
              <div className="detail-order__rent-detail-title">
                <h1>Detail Sewa</h1>
              </div>
              <div className="detail-order__rent-detail-body">
                <InputField
                  label="Lokasi Pengantaran"
                  disabled
                  value={newOrderData?.data?.order_detail?.rental_delivery_location || '-'}
                />
                <InputField
                  label="Detail Lokasi Pengantaran"
                  disabled
                  value={newOrderData?.data?.order_detail?.rental_delivery_location_detail || '-'}
                />
                {newOrderData?.data?.order_detail?.flight_number ? (
                  <InputField
                    label="Nomor Penerbangan"
                    disabled
                    value={newOrderData?.data?.order_detail?.flight_number || '-'}
                  />
                ) : null}
                {newOrderData?.data?.order_detail?.landing_time ? (
                  <InputField
                    label="Waktu Mendarat"
                    disabled
                    value={newOrderData?.data?.order_detail?.landing_time || '-'}
                  />
                ) : null}

                <InputField
                  label="Lokasi Pengambilan"
                  disabled
                  value={newOrderData?.data?.order_detail?.rental_return_location || '-'}
                />
                <InputField
                  label="Detail Lokasi Pengambilan"
                  disabled
                  value={newOrderData?.data?.order_detail?.rental_return_location_detail || '-'}
                />

                <InputField
                  label="Tipe Sewa"
                  disabled
                  value={newOrderData?.data?.order_type_id === 1 ? 'Harian' : '-'}
                />
                <InputField
                  label="Jenis Mobil"
                  disabled
                  value={newOrderData?.data?.order_detail?.vehicle?.name ?? '-'}
                />

                <div className="detail-order__rent-detail-body__rent-date">
                  <InputField
                    label="Tanggal Mulai"
                    disabled
                    value={
                      newOrderData?.data?.order_detail?.start_booking_date
                        ? indonesianDateFormat(newOrderData?.data?.order_detail?.start_booking_date)
                        : '-'
                    }
                  />
                  <InputField
                    label="Jam Mulai"
                    disabled
                    value={newOrderData?.data?.order_detail?.start_booking_time || '-'}
                  />
                </div>

                <div className="detail-order__rent-detail-body__rent-date">
                  <InputField
                    label="Tanggal Selesai"
                    disabled
                    value={
                      newOrderData?.data?.order_detail?.end_booking_date
                        ? indonesianDateFormat(newOrderData?.data?.order_detail?.end_booking_date)
                        : '-'
                    }
                  />
                  <InputField
                    label="Jam Selesai"
                    disabled
                    value={newOrderData?.data?.order_detail?.end_booking_time || '-'}
                  />
                </div>

                <div className="detail-order__rent-detail-body__rent-date">
                  <InputField
                    label="Jumlah Penumpang"
                    icon={<CarChair />}
                    iconPosition="start"
                    disabled
                    value={
                      newOrderData?.data?.order_detail?.passenger_number
                        ? `${newOrderData?.data?.order_detail?.passenger_number} Orang`
                        : '0'
                    }
                  />
                  <InputField
                    label="Plat Mobil"
                    disabled
                    value={newOrderData?.data?.order_detail?.vehicle?.license_number ?? '-'}
                  />
                </div>

                <div className="detail-order__rent-detail-body__rent-date">
                  <InputField
                    label="Kapasitas Koper"
                    disabled
                    value={newOrderData?.data?.order_detail?.vehicle?.max_suitcase ?? '-'}
                  />
                  <InputField
                    label="Koper yang dibawa"
                    disabled
                    value={newOrderData?.data?.order_detail?.baggage ?? 0}
                  />
                </div>

                {newOrderData?.data?.customer_name_meet_and_greet ? (
                  <InputField
                    label="Meet and Greet Board"
                    disabled
                    value={newOrderData?.data?.customer_name_meet_and_greet || '-'}
                  />
                ) : null}
              </div>
            </div>

            <div className="detail-order__price-detail">
              <div className="detail-order__price-detail-title">
                <h1>Detail Deposit</h1>
              </div>
              <div className="detail-order__price-detail-body">
                <InputField label="Nama Akun" disabled value={customerAccountBank.nama_rek || '-'} />
                <InputField label="No Rekening" disabled value={customerAccountBank.no_rek || '-'} />
                <InputField label="Nama Bank" disabled value={customerAccountBank.nama_bank || '-'} />
              </div>
            </div>

            <AddOnsField data={newOrderData?.data?.addons} totalPrice={newOrderData?.data?.addon_total_price} />

            <div className="detail-order__voucher-detail">
              <div className="detail-order__voucher-detail-title">
                <h1>Voucher</h1>
              </div>
              <div className="detail-order__voucher-detail-body">
                <InputField label="Nama Voucher" disabled value={newOrderData?.data?.vouchers?.[0].name || '-'} />
                <InputField label="Kode Voucher" disabled value={newOrderData?.data?.vouchers?.[0].code || '-'} />
                <InputField
                  label="Harga Potongan"
                  disabled
                  value={setCurrency(newOrderData?.data?.vouchers?.[0].value) || '-'}
                />
              </div>
            </div>

            <div className="detail-order__price-detail">
              <div className="detail-order__price-detail-title">
                <h1>Rincian Biaya</h1>
              </div>
              <div className="detail-order__price-detail-body">
                <InputField
                  label="Biaya Sewa Mobil"
                  disabled
                  value={setCurrency(newOrderData?.data?.booking_price) || '-'}
                />
                <InputField label="Deposit" disabled value={setCurrency(newOrderData?.data?.deposit) || '-'} />
                <InputField
                  label="Deposit e-Toll"
                  disabled
                  value={setCurrency(newOrderData?.data?.deposit_e_toll) || '-'}
                />
                <InputField
                  label="Pembayaran Dengan Point"
                  disabled
                  value={newOrderData?.data?.point}
                  icon={<PointsIcon />}
                  iconPosition="start"
                />
                <InputField label="Overtime" disabled value={setCurrency(newOrderData?.data?.over_time_price) || '-'} />
                <InputField
                  label="One Day Charge"
                  disabled
                  value={setCurrency(newOrderData?.data?.one_day_order_charge) || '-'}
                />
                <InputField
                  label="Outside Operational Hour Charge"
                  disabled
                  value={setCurrency(newOrderData?.data?.outside_operational_charge) || '-'}
                />
                <InputField
                  label="Exceed Max Passenger Charge"
                  disabled
                  value={setCurrency(newOrderData?.data?.exceed_passenger_price) || '-'}
                />
                <InputField
                  label="Biaya Lokasi Pengantaran"
                  disabled
                  value={setCurrency(newOrderData?.data?.rental_delivery_fee) || '-'}
                />
                <InputField
                  label="Biaya Pengembalian"
                  disabled
                  value={setCurrency(newOrderData?.data?.rental_return_fee) || '-'}
                />
                {newOrderData?.data?.price_component
                  ?.filter((item) => item?.type === 'charges')
                  ?.map((item, idx) => (
                    <InputField
                      key={idx}
                      label={`Holiday Charge (${item?.label})`}
                      disabled
                      value={setCurrency(item?.amount, newOrderData?.data?.currency) || '-'}
                    />
                  ))}
                <InputField
                  label="Charge Payment Gateway Platform"
                  disabled
                  value={setCurrency(newOrderData?.data?.disbursement?.total_amount_external_payment_fee) || '-'}
                />
                <InputField
                  label="Customer Service Platform"
                  disabled
                  value={setCurrency(newOrderData?.data?.disbursement?.total_amount_customer_service_fee) || '-'}
                />

                {newOrderData?.data?.fee_meet_greet_board ? (
                  <InputField
                    label="Biaya Meet and Greet Board"
                    disabled
                    value={
                      newOrderData?.data?.fee_meet_greet_board
                        ? setCurrency(newOrderData.data.fee_meet_greet_board)
                        : '-'
                    }
                  />
                ) : null}
              </div>
              <div className="detail-order__price-detail-body__input-violation">
                <InputViolation
                  violationList={[]}
                  totalPrice={newOrderData?.data?.order_violations
                    ?.map((item) => item.cost)
                    ?.reduce((acc, cVal) => acc + cVal, 0)}
                  violationPrice={0}
                  data={newOrderData?.data?.order_violations || []}
                  isOnEdit={false}
                />
              </div>
              <div className="detail-order__price-detail-body__input-violation">
                <InputAdditionals
                  additionalList={[]}
                  totalPrice={newOrderData?.data?.order_additional_fees
                    ?.map((item) => item.value)
                    ?.reduce((acc, cVal) => acc + cVal, 0)}
                  additionalPrice={0}
                  data={newOrderData?.data?.order_additional_fees || []}
                  isOnEdit={false}
                />
              </div>
              <div className="detail-order__price-detail-body__payment-type">
                <div className="detail-order__price-detail-body">
                  <InputField
                    label="Tipe Pembayaran"
                    disabled
                    value={newOrderData?.data?.type === 'HALF' ? 'Pembayaran DP 50%' : 'Pembayaran Full'}
                  />
                  <InputField
                    label="Biaya Bayar DP 50%"
                    disabled
                    value={newOrderData?.data?.type === 'HALF' ? setCurrency(newOrderData?.data?.down_payment) : '-'}
                  />
                  <InputField
                    label="Biaya selanjutnya yang harus dibayar"
                    disabled
                    value={newOrderData?.data?.type === 'HALF' ? setCurrency(newOrderData?.data?.remainder) : '-'}
                  />
                  {newOrderData?.data?.type === 'HALF' ? (
                    <InputField
                      label="Status Pembayaran DP"
                      disabled
                      value={newOrderData?.data?.payment_time === null ? 'Belum Lunas' : 'Lunas' || '-'}
                    />
                  ) : null}
                  <InputField
                    label="Total Harga Bersih"
                    disabled
                    value={setCurrency(newOrderData?.data?.disbursement?.total_net_amount) || '-'}
                  />
                  <InputField
                    label="Total Bruto"
                    disabled
                    value={setCurrency(newOrderData?.data?.disbursement?.total_amount_with_customer_service_fee) || '-'}
                  />
                </div>
              </div>

              <div className="detail-order__price-detail-body__payment-total">
                <div className="detail-order__price-detail-body">
                  <InputField
                    label="Total Keseluruhan"
                    disabled
                    value={setCurrency(newOrderData?.data?.total_payment) || '-'}
                  />
                  <InputField
                    label="Harga Selisih"
                    disabled
                    value={setCurrency(newOrderData?.data?.total_diff_price_with_approval) || '-'}
                  />
                </div>
              </div>
            </div>

            <div className="detail-order__payment-detail">
              <div className="detail-order__payment-detail-title">
                <h1>Pembayaran</h1>
              </div>
              <div className="detail-order__payment-detail-body">
                <InputField label="Status Pembayaran" disabled value={newOrderData?.data?.order_status || '-'} />

                <div className="detail-order__payment-detail-body__payment-method">
                  <InputField
                    label="Metode Pembayaran"
                    disabled
                    value={
                      newOrderData?.data?.disbursement?.payment?.method
                        ? newOrderData?.data?.disbursement.payment.method
                        : '-'
                    }
                  />
                </div>

                {Object.prototype.hasOwnProperty.call(newOrderData, 'disbursement') ? (
                  <>
                    <InputField
                      label="Nama Rekening"
                      disabled
                      value={
                        Object.prototype.hasOwnProperty.call(newOrderData, 'disbursement_reconfirmation')
                          ? [...newOrderData.data.disbursement_reconfirmation].pop()?.sender_name
                          : newOrderData?.data?.disbursement?.sender_name || '-'
                      }
                    />

                    <InputField
                      label="Nama Bank"
                      disabled
                      value={
                        Object.prototype.hasOwnProperty.call(newOrderData, 'disbursement_reconfirmation')
                          ? [...newOrderData.data.disbursement_reconfirmation].pop()?.sender_bank_name
                          : newOrderData?.data?.disbursement?.sender_bank_name || '-'
                      }
                    />

                    <div className="detail-order__payment-detail-body__preview-image">
                      <InputField
                        label="Foto Bukti Transfer"
                        disabled
                        value={getFileName(
                          Object.prototype.hasOwnProperty.call(newOrderData, 'disbursement_reconfirmation')
                            ? [...newOrderData.data.disbursement_reconfirmation].pop()?.reconfirmation_image
                            : newOrderData?.data?.disbursement?.disbursement_confirmation_image,
                        )}
                        className="preview-image-input"
                      />

                      <Button
                        bgColor="#D9D9D9"
                        textColor="#000000"
                        className="preview-image-btn"
                        onClick={() =>
                          imagePreviewHandler(
                            Object.prototype.hasOwnProperty.call(newOrderData, 'disbursement_reconfirmation')
                              ? [...newOrderData.data.disbursement_reconfirmation].pop()?.reconfirmation_image
                              : newOrderData?.data?.disbursement?.disbursement_confirmation_image,
                          )
                        }
                      >
                        Lihat
                      </Button>
                    </div>

                    <div />
                  </>
                ) : null}
              </div>
            </div>
          </>
        )}

        <div className="detail-order__transaction-buttons">
          <Button variant="outline" className="button" width={208} size="sm" onClick={backHandler}>
            Kembali
          </Button>

          {newOrderData?.status === 'pending' ? (
            <Button className="button" width={208} size="sm" onClick={() => confirmHandler('processed')}>
              Process
            </Button>
          ) : newOrderData?.status === 'processed' ? (
            <>
              <Button
                size="sm"
                className="button"
                width={208}
                variant="danger"
                onClick={() => confirmHandler('rejected')}
              >
                Tolak
              </Button>
              <Button className="button" width={208} size="sm" onClick={() => confirmHandler('approved')}>
                Konfirmasi
              </Button>
            </>
          ) : null}
        </div>
      </TableWrapper>
    </div>
  );
};

export default WithoutDriverDetail;
